<template>
  <el-dialog
    :title="modalTitle"
    :visible.sync="formModalOpened"
    :before-close="handleClose"
  >
    <el-row :gutter="20">
      <el-col :span="20" :offset="2">
        <el-form
          ref="createCompanyForm"
          :model="formData"
          :rules="rules"
          :label-width="$root.labelWidth"
          label-position="top"
          v-loading="creating">

          <el-row :gutter="20">
            <el-col :span="12">
              <el-form-item :label="$t('modules.company.fields.name.label')" prop="name">
                <el-input type="text" v-model.lazy.trim="formData.name" :placeholder="$t('modules.company.fields.name.placeholder')"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">

            </el-col>
          </el-row>
          
        </el-form>
      </el-col>
    </el-row>

    <span slot="footer" class="dialog-footer">
      <el-button type="primary" @click="submitForm()" :loading="processing">Save</el-button>
      <el-button @click="handleClose">Close</el-button>
    </span>

  </el-dialog>
</template>

<script>
  import { mapActions, mapGetters } from 'vuex';
  import { get } from 'lodash';

  import validations from '@/utils/validations';
  import formPopulator from '@/mixins/form_populator';
  import { showSuccessMessage, showErrorMessage } from '@/ui/message';

  export default {
    name: 'CompanyFormModal',
    mixins: [formPopulator],
    data() {
      return {
        processing: false,
        rules: {
          name: [
            { ...validations.required },
          ],
        },
        formData: {
          name: '',
        },
      };
    },
    created() {
    },
    computed: {
      ...mapGetters('entities/companies', ['creating', 'formModalContext']),

      formModalOpened: {
        get() {
          return this.$store.getters['entities/companies/formModalOpened'];
        },
        set(newValue) {
          if (!newValue) {
            this.handleClose();
          }
        },
      },
      editMode() {
        return get(this, 'formModalContext.companyId') !== undefined;
      },

      modalTitle() {
        return this.editMode ? 'Edit Company' : 'Add New Company';
      },
    },
    methods: {
      ...mapActions('entities/companies', ['createCompany', 'updateCompany', 'closeFormModal']),

      handleClickSubmit() {
        this.$refs.form.submitForm();
      },

      submitForm() {
        this.$refs.createCompanyForm.validate((valid) => {
          if (valid) {
            if (this.editMode) {
              this.updateCompany({ id: this.formModalContext.companyId, data: this.formData })
                .then((response) => {
                  if (response.status) {
                    showSuccessMessage('Company account has been edited successfully');
                    this.handleClose();
                  } else {
                    showErrorMessage(response.error);
                  }
                });
            } else {
              this.createCompany(this.formData)
                .then((response) => {
                  if (response.status) {
                    showSuccessMessage('Company account has been created.');
                    this.handleClose();
                  } else {
                    showErrorMessage(response.error);
                  }
                });
            }
          } else {
            showErrorMessage(this.$t('form.messages.notValid'));

            return false;
          }

          return true;
        });
      },

      populateForm() {
        const company = this.$store.getters['entities/companies/find'](this.formModalContext.companyId);
        this.populateFormWithModel(company);
      },

      clearForm() {
        this.$refs.createCompanyForm.resetFields();
      },

      handleClose() {
        this.closeFormModal();
        this.clearForm();
      },
    },
    watch: {
      editMode(newValue) {
        if (newValue) {
          this.populateForm();
        }
      },
    },
  };
</script>



// WEBPACK FOOTER //
// src/components/company/CompanyFormModal.vue